export const getDisplayName = (fullName?: string): string => {
  if (!fullName) return '';
  const words = fullName?.trim()?.split(' ');
  return words.length === 1 ? words[0] : `${words[0]} ${words[1]}`;
};
